// extracted by mini-css-extract-plugin
export var acitonButtons = "_h5-0";
export var additionalIcon = "_h5-f";
export var block = "_h5-1";
export var blockContent = "_h5-7";
export var blockDescription = "_h5-8";
export var blockIcon = "_h5-9";
export var blockTitle = "_h5-6";
export var border = "_h5-a";
export var center = "_h5-l";
export var edge = "_h5-b";
export var edgeLabel = "_h5-c";
export var edgePath = "_h5-d";
export var error = "_h5-e";
export var flowchart = "_h5-g";
export var flowchartContent = "_h5-h";
export var highlighted = "_h5-3";
export var hover = "_h5-4";
export var icon = "_h5-i";
export var left = "_h5-m";
export var navButton = "_h5-j";
export var navButtons = "_h5-k";
export var right = "_h5-n";
export var selected = "_h5-2";
export var small = "_h5-5";